import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Row,
  Typography,
  Card,
  Statistic,
  Table,
  Form,
  Button,
  Divider,
  Modal,
  List,
  Spin,
} from "antd";
import {
  SearchOutlined,
  ReloadOutlined,
  LeftOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import MainLayout from "../../../../../../components/layouts/MainLayout";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../../../../components/layouts/TopContent";
import {
  onSelectItemAction,
  rightAction,
} from "../../../../../../redux/actions";
import DownloadTableButtons from "../../../../../../components/DownloadTableButtons";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import SearchJournalEntries from "./SavingsAccSearchJournalEntries";
import { isDebit } from "../../../../../../components/facilities/AccountFacility";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Entry ID",
    dataIndex: "id",
  },
  {
    title: "Branch",
    dataIndex: "branch",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
    sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
  },
  {
    title: "Transaction Tag",
    dataIndex: "transactionTag",
  },
  {
    title: "Transaction ID",
    dataIndex: "transactionId",
  },
  {
    title: "Account",
    dataIndex: "account",
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
];

const SavingsAccManageJournalEntries = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const navigate = useNavigate();
  const { state } = useLocation();
  const { session } = userData;
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();

  useEffect(() => {
    getJournalEntryListAction(state);
  }, []);

  const getJournalEntryListAction = (state) => {
    const params = {
      dateFormat: "dd MMMM yyyy",
      limit: 14,
      locale: "en",
      offset: 0,
      savingsId: state.id,
      sortOrder: "DESC",
      orderBy: "transactionDate",
    };
    const url = `${apiConfig.JournalEntries}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          console.log(element);
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            branch: element?.officeName ? element?.officeName : "-",
            transactionDate: element?.transactionDate
              ? BOM.FormatArrayDate(element?.transactionDate)
              : "-",
            transactionId: element?.transactionId
              ? element?.transactionId
              : "-",
            type: element?.glAccountType?.value
              ? element?.glAccountType?.value
              : "-",
            createdBy: element?.createdByUserName
              ? element?.createdByUserName
              : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "-",
            transactionTag: element?.entryType?.value
              ? element?.entryType?.value === "DEBIT"
                ? "Dr"
                : element?.entryType?.value === "CREDIT"
                ? "Cr"
                : "-"
              : "-",
            amount:
              element?.amount !== null && element?.amount !== undefined
                ? Number(element.amount).toFixed(2)
                : "0.00",

            debit: isDebit(element.transactionTypeDetail)
              ? element.amount
              : "-",
            credit: !isDebit(element.transactionTypeDetail)
              ? element.amount
              : "-",

            amountDisplay: element?.amount ? (
              <Statistic
                value={element.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              "-"
            ),
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setJournalEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  //DECLARED METHODS
  const onRefresh = () => {
    useForm.resetFields();
    getJournalEntryListAction(state);
  };

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-savings-journal-entries", {
        state: { ...state, transactionId: selectedRow.transactionId },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function backOnClick() {
    navigate("/detail-savings-account", { state: state });
  }

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.journalEntries}
        pageItems={staticConfig.journalEntriesBreadcrumbItems}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        title={
          <Row
            style={{
              alignContent: "center",
              //   width: "8%",
            }}
          >
            <Button
              icon={<LeftOutlined />}
              type="text"
              style={{
                marginTop: "auto",
                marginBottom: "auto",
              }}
              onClick={backOnClick}
            >
              <Text
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  fontSize: 15,
                }}
              >
                Back
              </Text>
            </Button>
          </Row>
        }
      >
        <Spin spinning={isLoading} size="large">
          <Row>
            <Row style={{ marginBottom: 20 }}>
              <SearchJournalEntries
                currentAccountObj={state}
                journalEntryList={journalEntryList}
                setJournalEntryList={setJournalEntryList}
              />
              <Button
                type="primary"
                shape="round"
                className="of-primaryBtnColor"
                onClick={onRefresh}
                icon={<ReloadOutlined />}
                loading={isLoading}
                style={{
                  marginLeft: 10,
                  marginBottom: "auto",
                }}
              >
                {labelConfig.refresh}
              </Button>
              {/* <DownloadTableButtons
              downloadData={journalEntryList}
              columns={columns}
              fileName={"Journal Entry List"}
            /> */}
            </Row>
            <DownloadTableButtons
              downloadData={journalEntryList.map((row) => ({
                ...row,
                amountDisplay: undefined, // remove React element
              }))}
              columns={columns}
              fileName={"Savings Journal Entry List"}
            />
          </Row>
          <Divider />
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={journalEntryList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

// export default SavingsAccManageJournalEntries;
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SavingsAccManageJournalEntries);
